import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"

import { find, flatMap, get, isEmpty } from "lodash"
import {
  Drawer,
  Button,
  Select,
  Popover,
  Divider,
  Checkbox,
  Input,
  Form,
  Switch,
  Tooltip,
} from "antd"

import "./index.less"
import Loader from "../Loader"
import { DeleteIcon } from "../../icons/svg/iconDelete"
import { LockIcon } from "../../icons/svg/iconLock"
import { validate } from "../../utils/functions"
import { TYPE_QUESTION, TYPE_SURVEY } from "../../utils/constants"
import LikertForm from "./components/LikertForm"
import EnpsForm from "./components/EnpsForm"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import SelectTypeQuestion from "./components/SelectTypeQuestion"
import CheckboxEngagement from "./components/CheckboxEngagement"
import NpsForm from "./components/NpsForm"
import MultipleChoiceForm from "./components/MultipleChoiceForm"
import ModalDeleteQuestion from "../ModalDeleteQuestion"
import Ponderated from "./components/Ponderated"
import { verifyFeatureFlag } from "../../utils/feature-flags"
import QuestionSegments from "./components/QuestionSegments"
import { QuestionIcon } from "../../icons/svg/iconQuestion"

const { TextArea } = Input

export function QuestionDrawer(props) {
  const [idQuestionType, setQuestionType] = useState(TYPE_QUESTION.likert)
  const [idQuestionTypeOriginal, setQuestionTypeOriginal] = useState(
    TYPE_QUESTION.likert
  )
  const [questionName, setQuestionName] = useState("")
  const [questionNameOriginal, setQuestionNameOriginal] = useState(undefined)
  const [questionEnps, setQuestionEnps] = useState(
    "Recomendaría esta organización como lugar de trabajo a mis amigos."
  )
  const [questionNps, setQuestionNps] = useState(
    "Recomendaría a mi líder a otro compañero de trabajo."
  )
  const [infoEditSegment, setInfoEditSegment] = useState([])
  const [engagementCheck, setEngagementCheck] = useState(false)
  const [dimensions, setDimensions] = useState(undefined)
  const [dimensionsOriginal, setDimensionsOriginal] = useState(undefined)
  const [generic, setGeneric] = useState(false)
  const [imported, setImported] = useState(false)
  const [enpsTextLeft, setEnpsTextLeft] = useState("Totalmente en desacuerdo")
  const [enpsTextCenter, setEnpsTextCenter] = useState("")
  const [enpsTextRight, setEnpsTextRight] = useState("Totalmente de acuerdo")
  const [ponderated, setPonderated] = useState("1")
  const [formQuestionDrawer] = Form.useForm()
  const [scaleEnps, setScaleEnps] = useState("5")
  const [lastQuestion, setLastQuestion] = useState(true)
  const [isModalDelete, setIsModalDelete] = useState(false)

  const [multipleAnswerList, setMultipleAnswerList] = useState([])
  const [isMultipleChoiceCkecked, setIsMultipleChoiceCkecked] = useState(false)
  const [isValidMultipleChoice, setIsValidMultipleChoice] = useState(true)
  const [validQuestSegments, setvalidQuestSegments] = useState(true)
  const [questionForSegments, setquestionForSegments] = useState([])
  const [validEdit, setValidEdit] = useState(false)
  const [switchQuestion, setswitchQuestion] = useState(false)
  const featureFlagSegment = verifyFeatureFlag("seg2-5")
  useEffect(() => {
    const { questionData, surveyData } = props

    if (
      validate.exist(questionData) &&
      validate.exist(questionData.id_question)
    ) {
      setQuestionType(questionData.id_question_type)
      setQuestionTypeOriginal(questionData.id_question_type)
      setGeneric(questionData.generic)
      setImported(questionData.imported)
      setQuestionName(questionData.name)
      setValidEdit(false)
      setQuestionNameOriginal(questionData.name)
      setswitchQuestion(questionData.required)
      let dimensionIs = null
      if (questionData.dimensions.length === 1) {
        dimensionIs = questionData.dimensions[0].id_dimension_has_survey
      } else {
        dimensionIs = flatMap(
          questionData.dimensions,
          (item) => item.id_dimension_has_survey
        )
      }
      if (questionData.id_question_type === TYPE_QUESTION.multiple_choice) {
        const listAux = questionData.answer_options.map((row) => {
          return {
            answer: row,
            editTagIsDisabled: true,
          }
        })
        setMultipleAnswerList(listAux)
        setIsMultipleChoiceCkecked(questionData.multiple_responses)
      }
      setDimensions(dimensionIs)
      setDimensionsOriginal(dimensionIs)
      setPonderated(`${parseInt(questionData.ponderated * 1)}`)
      setScaleEnps(`${questionData.enps_scale}`)
      setEngagementCheck(questionData.engagement)
      setLastQuestion(questionData.last_question)
      setEnpsTextLeft(questionData.enps_text_left)
      setEnpsTextCenter(questionData.enps_text_center)
      setEnpsTextRight(questionData.enps_text_right)

      formQuestionDrawer.setFieldsValue({
        question_name: questionData.name,
        text_enps_left: questionData.enps_text_left,
        text_enps_right: questionData.enps_text_right,
      })
    }
  }, [props.questionData])

  useEffect(() => {
    if (props.isLoadingSave === false) {
      restartValues()
    }
  }, [props.isLoadingSave])

  useEffect(() => {
    if (multipleAnswerList.length > 1) {
      setIsValidMultipleChoice(true)
    }
  }, [multipleAnswerList])

  const renderTitle = () => {
    const { isCreate, surveyData, isLoading } = props

    if (isLoading) {
      return null
    }
    if (isCreate) {
      return "Nueva pregunta"
    }
    return (
      <div className="QuestionDrawer__Header">
        <div className="QuestionDrawer__Header--title">Editar pregunta</div>
        {!generic && surveyData.measures?.length === 0 && (
          <Button
            className="QuestionDrawer__Header--button"
            type="link"
            onClick={() => setIsModalDelete(true)}
            icon={
              <DeleteIcon
                style={{
                  color: "#C5C2C2",
                }}
              />
            }
          />
        )}
      </div>
    )
  }

  const renderContainer = () => {
    const { isLoading, surveyData } = props

    if (isLoading) {
      return (
        <div className="QuestionDrawer__Content">
          <Loader />
        </div>
      )
    }
    const validateMessages = {
      required: "Campo obligatorio",
    }

    return (
      <div className="QuestionDrawer__Content">
        <Form
          form={formQuestionDrawer}
          id="formQuestionDrawer"
          validateMessages={validateMessages}>
          {renderSelectTypeQuestion()}
          {renderCheckboxEngagement()}
          {featureFlagSegment &&
            (
              idQuestionType == TYPE_QUESTION.likert ?
                <>
                  {renderFormByQuestionType()}
                  <Divider style={{ margin: "16px 0" }} />
                  {renderQuestion()}
                  {surveyData.segments !== undefined && (

                    <>
                      {renderQuestionSegments()}  </>)}

                </>
                :
                <>
                  {renderQuestion()}
                  {surveyData.segments !== undefined && (
                    <>
                      {renderQuestionSegments()}  </>)}
                  <Divider style={{ margin: "16px 0" }} />
                  {renderFormByQuestionType()}
                </>
            )
          }

          {
            !featureFlagSegment &&
            <>
              {renderQuestion()}
              {surveyData.segments !== undefined && (
                <>

                  {renderQuestionSegments()}  </>)}

              {idQuestionType !== TYPE_QUESTION.qualitative && (
                <Divider style={{ margin: "16px 0" }} />
              )}
              {renderFormByQuestionType()}
            </>
          }

          {!featureFlagSegment && (<Divider style={{ margin: "16px 0" }} />)}

          {idQuestionType == TYPE_QUESTION.likert && featureFlagSegment && renderPonderated()}
          {featureFlagSegment && (<Divider style={{ margin: "16px 0" }} />)}
          {!featureFlagSegment && renderTranslation()}
        </Form>
      </div>
    )
  }

  const renderPonderated = () => {
    const { surveyData } = props
    return <Ponderated
      onChangePonderated={onChangePonderated}
      ponderated={ponderated}
      engagementCheck={engagementCheck}
      surveyData={surveyData}
    />

  }


  const renderSelectTypeQuestion = () => {
    const { isCreate, questionData, surveyData, questionTypes } = props
    return (
      <SelectTypeQuestion
        isCreate={isCreate}
        questionData={questionData}
        surveyData={surveyData}
        idQuestionType={idQuestionType}
        onChangeTypeQuestion={onChangeTypeQuestion}
        engagementCheck={engagementCheck}
        questionTypes={questionTypes}
      />
    )
  }

  const onChangeTypeQuestion = (valueChange) => {
    const { surveyData } = props

    saveAttributesQuestionSegment(
      "Tipo de pregunta",
      idQuestionTypeOriginal === valueChange
    )
    setQuestionType(valueChange)
    if (parseInt(valueChange) === TYPE_QUESTION.enps) {
      if (surveyData.id_survey_type === TYPE_SURVEY.leadership.idSurveyType) {
        formQuestionDrawer.setFieldsValue({
          text_enps_left: "Totalmente en desacuerdo",
          question_name: questionNps,
          text_enps_right: "Totalmente de acuerdo",
        })
        setEnpsTextLeft("Totalmente en desacuerdo")
        setEnpsTextCenter("")
        setEnpsTextRight("Totalmente de acuerdo")
        setQuestionName(questionNps)
      } else {
        formQuestionDrawer.setFieldsValue({
          text_enps_left: "Totalmente en desacuerdo",
          question_name: questionEnps,
          text_enps_right: "Totalmente de acuerdo",
        })
        setEnpsTextLeft("Totalmente en desacuerdo")
        setEnpsTextCenter("")
        setEnpsTextRight("Totalmente de acuerdo")
        setQuestionName(questionEnps)
      }
    } else {
      setQuestionName(undefined)
      formQuestionDrawer.setFieldsValue({
        question_name: undefined,
      })
    }
    const validQuestion = questionForSegments.length == undefined ? true : (questionForSegments.length == 0)
    if (surveyData.segments !== undefined && validQuestion) {
      featureFlagSegment ? setvalidQuestSegments(false) : setvalidQuestSegments(true)
    }
  }
  const validateformQuestionDrawer = (segments, type) => {
    var validation = false;

    let segmentos = segments
    if (type == 2) {
      validation = true
      segmentos = segments.filter((element, index) => {
        if (!props.isCreate) {
          const questionFind = props.questionData.questions_segments.find(i => i.id_segment === element.id_segment)
          if (questionFind) element.id_question_has_segment = questionFind.id_question_has_segment
          return true;
        }
        if (element.checked === true && element.question.trim() != '') {
          // validation = true
          return true;
        }
        return false;
      });
      if (!props.isCreate) {
        var changeQ = false;
        const data = segmentos.map((item, index) => {
          const question = props.questionData.questions_segments.find(i => i.id_segment === item.id_segment)
          if (question) {
            if (question.name != item.question && question.name != '') {
              changeQ = true;
            }
          } else {
            changeQ = true;
          }


        }
        );
        setValidEdit(changeQ);
      }

    }
    setquestionForSegments(segmentos);

    // se filtra los segmentos con check
    let segmentSelected = segments.filter(segment => segment.checked)


    // si hay segmentos seleccionados, y cada uno tiene un texto de pregunta, entonces es valido
    validation = segmentSelected.length > 0 && segmentSelected.every(segment => {
      return segment.question !== undefined && segment.question?.trim() != ''
    })



    // console.log('segment every final',segmentSelected.every(segment => {
    //   return segment.question !== undefined && segment.question?.trim() != ''
    // }))
    if (!props.isCreate && type == 1) {
      setValidEdit(validation);
    }
    setvalidQuestSegments(validation)
    
    isValidateForm()
  }
  const onChangeQuestionForSegments = (valueChange, item) => {
    const { surveyData } = props

  }

  const saveAttributesQuestionSegment = (name, isEqualAttribute) => {
    const infoEditSegmentAux = [...infoEditSegment]
    const index = infoEditSegment.indexOf(name)
    if (isEqualAttribute === false && index == -1) {
      infoEditSegmentAux.push(name)
    }
    if (isEqualAttribute && index != -1) {
      infoEditSegmentAux.splice(index, 1)
    }
    setInfoEditSegment(infoEditSegmentAux)
  }

  const renderCheckboxEngagement = () => {
    const { surveyData, isCreate } = props
    const { id_survey_type } = surveyData
    if (idQuestionType === TYPE_QUESTION.multiple_choice) {
      return null
    }
    if (id_survey_type > 2) {
      return null
    }
    return (
      <CheckboxEngagement
        surveyData={surveyData}
        isCreate={isCreate}
        idQuestionType={idQuestionType}
        engagementCheck={engagementCheck}
        generic={generic}
        onChangeEngagementCheck={onChangeEngagementCheck}
      />
    )
  }

  const onChangeEngagementCheck = (checked) => {
    setEngagementCheck(checked)
    setDimensions(undefined)
  }

  const renderQuestion = () => {
    const { surveyData, questionTypes } = props

    const id_calculation_type =
      (questionTypes[0] && questionTypes[0].id_survey_calculation_type) || 1
    return (
      <div className="Question">
        {(idQuestionType == TYPE_QUESTION.qualitative || idQuestionType == TYPE_QUESTION.multiple_choice) && (
          <div className="SwitchQuestion">
            <Switch
              checked={switchQuestion}
              onChange={(e) => {
                setswitchQuestion(e)
                if (!props.isCreate) {
                  if(e != props.questionData.required)
                  setValidEdit(true);
                }
              }}
            />
            <div style={{ marginRight: '8px' }} />
            <span style={{ marginRight: '8px' }}>Pregunta obligatoria</span>
            <Tooltip
              placement="top"
              overlayClassName="custom-tooltip"
              title={`Al activar el switch,\nserá obligatorio responder
               esta pregunta\ndurante el llenado de la encuesta.`}
            >
              <QuestionIcon />
            </Tooltip>
          </div>
        )}


        <div className="Question__Header">
          <div className="Question__Header--title">Pregunta*</div>
          <div className="Question__Header--lock">
            {(generic || surveyData.measures?.length > 0) && <LockIcon />}
          </div>
        </div>
        <div className="Question__Content">
          <Form.Item
            name="question_name"
            label=""
            rules={[
              {
                required: true,
              },
            ]}>

            <TextArea
              placeholder={
                idQuestionType === TYPE_QUESTION.likert
                  ? "Escribe la pregunta aquí..."
                  : "Escribe aquí tu pregunta..."
              }
              showCount
              maxLength={200}
              autoSize={{ maxRows: 4, minRows: 4 }}
              value={questionName}
              onChange={(e) => onChangeQuestionName(e.target.value.trimStart())}
            />
          </Form.Item>
        </div>
        <div>
          {id_calculation_type === 2 ? (
            <span style={{ fontSize: "12px", color: "#979797" }}>
              Los resultados de esta pregunta se calcularán usando una fórmula
              de <strong>promedio simple</strong>.
            </span>
          ) : (
            <span style={{ fontSize: "12px", color: "#979797" }}>
              Los resultados de esta pregunta se calcularán usando una fórmula
              de <strong>top two box</strong>
            </span>
          )}
        </div>
      </div>
    )
  }
  const renderQuestionSegments = () => {
    const { isCreate, questionData, surveyData, questionTypes } = props
    const validQuestion = questionData.questions_segments == undefined ? true : (questionData.questions_segments.length == 0)
    if (validQuestion && isCreate == false) {
      return;
    }
    if (!featureFlagSegment) { return }
    return (

      <QuestionSegments
        isCreate={isCreate}
        questionData={questionData}
        surveyData={surveyData}
        idQuestionType={idQuestionType}
        onChangeQuestionForSegments={onChangeQuestionForSegments}
        validateformQuestionDrawer={validateformQuestionDrawer}
        engagementCheck={engagementCheck}
        questionTypes={questionTypes}
      />
    )
  }
  const onChangeQuestionName = (valueChange) => {
    const { surveyData, isCreate } = props

    const validQuestion = questionForSegments.length == undefined ? true : (questionForSegments.length == 0)
    if (surveyData.segments !== undefined && validQuestion) {
      isCreate ? setvalidQuestSegments(false) : setvalidQuestSegments(true);
    }
    featureFlagSegment ? '' : setvalidQuestSegments(true)
    if (!isCreate) setValidEdit(true);
    saveAttributesQuestionSegment(
      "Pregunta",
      questionNameOriginal === valueChange
    )
    setQuestionName(valueChange)
    formQuestionDrawer.setFieldsValue({
      question_name: valueChange,
    })
  }

  const disableQuestion = () => {
    const { surveyData, isCreate } = props
    if (
      idQuestionType === TYPE_QUESTION.enps &&
      imported &&
      !isEmpty(questionName)
    ) {
      return false
    }

    if (idQuestionType === TYPE_QUESTION.qualitative && isCreate) {
      return false
    }

    if (surveyData.measures?.length) {
      return true
    }

    if (generic) {
      return !(generic && idQuestionType === TYPE_QUESTION.qualitative)
    }
    return generic || surveyData.measures?.length > 0
  }

  const renderFormByQuestionType = () => {
    const { isCreate, dimensionList, surveyData } = props
    switch (idQuestionType) {
      case TYPE_QUESTION.likert:
        return (
          <LikertForm
            isCreate={isCreate}
            engagementCheck={engagementCheck}
            dimensions={dimensions}
            ponderated={ponderated}
            dimensionList={dimensionList}
            onChangeDimension={onChangeDimension}
            onChangeOutcome={onChangeOutcome}
            onChangePonderated={onChangePonderated}
            surveyData={surveyData}
            disabledFields={
              !isCreate || generic || surveyData.measures?.length > 0
            }
          />
        )
        break
      case TYPE_QUESTION.qualitative:
        break
      case TYPE_QUESTION.enps:
        return surveyData.id_survey_type ===
          TYPE_SURVEY.leadership.idSurveyType ? (
          <NpsForm
            disabledFields={surveyData.measures?.length > 0}
            enpsTextLeft={enpsTextLeft}
            enpsTextCenter={enpsTextCenter}
            enpsTextRight={enpsTextRight}
            onChangeEnpsText={onChangeEnpsText}
            scaleEnps={scaleEnps}
            onChangeScaleEnps={onChangeScaleEnps}
          />
        ) : (
          <EnpsForm
            disabledFields={surveyData.measures?.length > 0}
            enpsTextLeft={enpsTextLeft}
            enpsTextCenter={enpsTextCenter}
            enpsTextRight={enpsTextRight}
            onChangeEnpsText={onChangeEnpsText}
            scaleEnps={scaleEnps}
            onChangeScaleEnps={onChangeScaleEnps}
          />
        )
        break
      case TYPE_QUESTION.multiple_choice:
        return (
          <MultipleChoiceForm
            disabledFields={surveyData.measures?.length > 0}
            onClickaddAnswerChoice={onClickaddAnswerChoice}
            multipleAnswerList={multipleAnswerList}
            onClickRemoveMultipleChoice={onClickRemoveMultipleChoice}
            onClickEditMultipleChoice={onClickEditMultipleChoice}
            handleOnChangeEdit={handleOnChangeEdit}
            handleOnEnterEdit={handleOnEnterEdit}
            onChangeMultipleChoiceCheck={onChangeMultipleChoiceCheck}
            isMultipleChoiceCkecked={isMultipleChoiceCkecked}
            isValidMultipleChoice={isValidMultipleChoice}
          />
        )
        break
      default:
        return null
    }
  }

  const onChangeMultipleChoiceCheck = (checked) => {
    setIsMultipleChoiceCkecked(checked)
  }

  const onClickaddAnswerChoice = (value) => {
    setMultipleAnswerList([
      ...multipleAnswerList,
      { answer: value, editTagIsDisabled: true },
    ])
  }

  const onClickRemoveMultipleChoice = (index) => {
    const list = [...multipleAnswerList]
    list.splice(index, 1)
    setMultipleAnswerList(list)
  }

  const onClickEditMultipleChoice = (index) => {
    const list = [...multipleAnswerList]
    list[index].editTagIsDisabled = false
    setMultipleAnswerList(list)
  }

  const handleOnChangeEdit = (e, index) => {
    const { name, value } = e.target
    const list = [...multipleAnswerList]
    list[index].answer = value.trimStart().trimEnd()
    setMultipleAnswerList(list)
  }

  const handleOnEnterEdit = (e, index) => {
    e.preventDefault()

    const list = [...multipleAnswerList]
    list[index].editTagIsDisabled = true
    setMultipleAnswerList(list)
  }

  const onChangeOutcome = (valueChange) => {
    const { dimensionList } = props
    const dimensionsWithEngagement =
      find(
        [...dimensionList],
        ({ data }) => data.name.toLowerCase() === "engagement"
      ) || []
    const filterByDimension = find(
      get(dimensionsWithEngagement, "children", []),
      ({ data }) => data.id_dimension_has_survey === valueChange
    )
    let message = ""
    if (filterByDimension) {
      message = filterByDimension.data.default_question
    }
    setDimensions(valueChange)
    setQuestionName(message)
    formQuestionDrawer.setFieldsValue({
      question_name: message,
    })
  }

  const onChangeDimension = (valueChange) => {
    saveAttributesQuestionSegment(
      "dimension",
      dimensionsOriginal === valueChange
    )
    if (Array.isArray(valueChange) && typeof dimensions === "string") {
      return setDimensions([dimensions, ...valueChange])
    }
    if (Array.isArray(valueChange)) {
      return setDimensions(valueChange)
    }
    setDimensions(valueChange)
  }

  const onChangePonderated = (valueChange) => {
    setPonderated(valueChange)
  }

  const onChangeScaleEnps = (valueChange) => {
    setScaleEnps(valueChange)
  }

  const onChangeEnpsText = ({ typeText, valueChange }) => {
    if (!props.isCreate) setValidEdit(true);
    switch (typeText) {
      case "left":
        setEnpsTextLeft(valueChange)
        break
      case "center":
        setEnpsTextCenter(valueChange)
        break
      case "right":
        setEnpsTextRight(valueChange)
        break
    }
  }

  const renderTranslation = () => {
    return (
      <div className="Translation">
        <div className="Translation__Header">Traducción</div>
        <div className="Translation__Select">
          <Select style={{ width: 314 }} value="spanish" disabled>
            <Select.Option value="spanish">Español</Select.Option>
          </Select>
        </div>
      </div>
    )
  }

  const renderFooter = () => {
    const { isLoadingSave, onClose, isCreate, isLoading } = props
    if (isLoading) {
      return null
    }
    if (hideFooterDrawer()) {
      return null
    }
    return (
      <div
        style={{
          textAlign: "right",
        }}>
        <Button
          style={{ marginRight: 8 }}
          onClick={() => {
            onClose()
            restartValues()
            Intercom('update', { hide_default_launcher: false });
          }}>
          Cancelar
        </Button>
        <Button
          form="formQuestionDrawer"
          key="submit"
          htmlType="submit"
          className={!isValidateForm() ? "disabled_button" : ""}
          type="primary"
          loading={isLoadingSave}
          onClick={() => onCreateQuestion()}>
          {isCreate ? "Crear" : "Guardar"}
        </Button>
      </div>
    )
  }

  const hideFooterDrawer = () => {
    const { questionData, isCreate } = props

    if (isCreate) return false

    if (idQuestionType === TYPE_QUESTION.likert) {
      let dimensionIs = null
      if (questionData.dimensions.length === 1) {
        dimensionIs = questionData.dimensions[0].id_dimension_has_survey
      } else {
        dimensionIs = flatMap(
          questionData.dimensions,
          (item) => item.id_dimension_has_survey
        )
      }
      return (
        dimensions === dimensionIs &&
        questionData.name === questionName &&
        validEdit === false &&
        questionData.id_question_type === idQuestionType &&
        Number(questionData.ponderated) === Number(ponderated)
      )
    }

    if (idQuestionType === TYPE_QUESTION.qualitative) {
      return (
        questionData.name === questionName &&
        validEdit === false &&
        questionData.id_question_type === idQuestionType &&
        questionData.required === switchQuestion
      )
    }

    if (idQuestionType === TYPE_QUESTION.enps) {
      return (
        questionData.enps_text_left === enpsTextLeft &&
        questionData.enps_text_center === enpsTextCenter &&
        questionData.enps_text_right === enpsTextRight &&
        questionData.id_question_type === idQuestionType &&
        questionData.name === questionName &&
        validEdit === false &&
        questionData.engagement === engagementCheck &&
        questionData.enps_scale === parseInt(scaleEnps)
      )
    }

    if (idQuestionType === TYPE_QUESTION.multiple_choice) {
      let multipleAnswerListAux = []
      multipleAnswerList.map((row) => {
        multipleAnswerListAux.push(row.answer)
      })
      var result = questionData.answer_options.filter((value) => {
        return multipleAnswerListAux.indexOf(value) == -1
      })
      var resultReverse = multipleAnswerListAux.filter((value) => {
        return (
          questionData.answer_options.indexOf(value) == -1 && value.length > 0
        )
      })

      return (
        questionData.name === questionName &&
        validEdit === false &&
        questionData.id_question_type === idQuestionType &&
        questionData.multiple_responses === isMultipleChoiceCkecked &&
        result.length === resultReverse.length &&
        questionData.required === switchQuestion &&
        (result.length === 0 || resultReverse.length === 0)
      )
    }

    return false
  }

  const isValidateForm = () => {
    if (!validate.exist(questionName) || questionName.length === 0) {
      return false
    }
    
    if (idQuestionType === TYPE_QUESTION.likert) {
      if (!validate.exist(dimensions)) {
        return false
      }
    }
    
    if (idQuestionType === TYPE_QUESTION.enps) {
      if (!validate.exist(enpsTextLeft) || enpsTextLeft.length === 0 || enpsTextLeft.length > 30) {
        return false
      }
      if (enpsTextCenter.length > 30) {
        return false
      }
      if (!validate.exist(enpsTextRight) || enpsTextRight.length === 0 || enpsTextRight.length > 30) {
        return false
      }
    }
    
    if (idQuestionType === TYPE_QUESTION.multiple_choice) {
      if (multipleAnswerList.length < 2) {
        return false
      }
    }
    
    if (props.surveyData.segments !== undefined) {
      if (!validQuestSegments) return false
      
      if (!props.isCreate && !validEdit) return false
    }
    return true
  }

  const transformMultipleChoiceData = (data) => data.map((item) => item.answer)

  const onCreateQuestion = () => {
    if (multipleAnswerList.length < 2) {
      setIsValidMultipleChoice(false)
    }
    if (!isValidateForm()) {
      return null
    }
    woopraTrack("Guardar nueva pregunta")
    const {
      idSurvey,
      questionData,
      isCreate,
      updateQuestionWatcher,
      createQuestionWatcher,
    } = props
    let params = {
      id_survey: idSurvey,
      id_question: isCreate ? null : questionData.id_question,
      name: questionName,
      id_question_type: idQuestionType,
      questionsSegments: questionForSegments
    }

    if (idQuestionType === TYPE_QUESTION.likert) {
      params = {
        ...params,
        ponderated: Number(ponderated),
        id_dimensions_has_surveys: [dimensions],
        engagement: Number(engagementCheck),
        infoEditSegment,
      }
    }

    if (idQuestionType === TYPE_QUESTION.enps) {
      params = {
        ...params,
        engagement: Number(engagementCheck),
        last_question: Number(lastQuestion),
        enps_text_left: enpsTextLeft,
        enps_text_center: enpsTextCenter,
        enps_text_right: enpsTextRight,
        enps_scale: parseInt(scaleEnps),
      }
    }

    if (idQuestionType === TYPE_QUESTION.multiple_choice) {
      params = {
        ...params,
        answer_options: transformMultipleChoiceData(multipleAnswerList),
        multiple_responses: Number(isMultipleChoiceCkecked),
      }
    }
    if (idQuestionType === TYPE_QUESTION.multiple_choice || idQuestionType === TYPE_QUESTION.qualitative) {
      params = {
        ...params,
        required: switchQuestion

      }
    }

    if (!isCreate) {
      updateQuestionWatcher({
        params,
        idQuestion: questionData.id_question,
      })
    } else {
      createQuestionWatcher(params)
    }
    Intercom('update', { hide_default_launcher: false });;
    return null
  }

  const restartValues = () => {
    setQuestionType(TYPE_QUESTION.likert)
    setQuestionTypeOriginal(TYPE_QUESTION.likert)
    setQuestionName(undefined)
    setValidEdit(false)
    setQuestionNameOriginal(undefined)
    setQuestionEnps(
      "Recomendaría esta organización como lugar de trabajo a mis amigos."
    )
    setQuestionNps("Recomendaría a mi líder a otro compañero de trabajo.")
    setInfoEditSegment([])
    if (props.surveyData.segments !== undefined) {
      featureFlagSegment ? setvalidQuestSegments(true) : setvalidQuestSegments(false)
    }
    setEngagementCheck(false)
    setDimensions(undefined)
    setDimensionsOriginal(undefined)
    setGeneric(false)
    setImported(false)
    setEnpsTextLeft("Totalmente en desacuerdo")
    setEnpsTextCenter("")
    setEnpsTextRight("Totalmente de acuerdo")
    setPonderated("1")
    setquestionForSegments({})
    formQuestionDrawer.setFieldsValue({
      question_name: undefined,
    })
    setScaleEnps("5")
    setMultipleAnswerList([])
    setIsMultipleChoiceCkecked(false)
    setswitchQuestion(false)
  }

  const deleteQuestion = (params) => {
    props.deleteQuestionWatcher(params)
    setIsModalDelete(false)
    props.onClose()
    restartValues()
  }

  const cancelDeleteQuestion = () => {
    setIsModalDelete(false)
  }

  return (
    <Fragment>
      <Drawer
        title={renderTitle()}
        width={550}
        onClose={() => {
          props.onClose()
          restartValues()
          Intercom('update', { hide_default_launcher: false });
        }}
        visible={props.visibleDrawer}
        bodyStyle={{ padding: "0" }}
        footer={renderFooter()}>
        {renderContainer()}
      </Drawer>

      <ModalDeleteQuestion
        modalOpen={isModalDelete}
        question={props.questionData}
        survey={props.surveyData}
        deleteQuestion={deleteQuestion}
        cancelDeleteQuestion={cancelDeleteQuestion}
        configSurvey={props.configSurvey}
      />
    </Fragment>
  )
}

QuestionDrawer.propTypes = {
  isLoading: PropTypes.bool,
  isLoadingSave: PropTypes.bool,
  isCreate: PropTypes.bool,
  visibleDrawer: PropTypes.bool,
  onClose: PropTypes.func,
  questionData: PropTypes.object,
  surveyData: PropTypes.object,
  questionTypes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  idSurvey: PropTypes.number,
  configSurvey: PropTypes.object,
  updateQuestionWatcher: PropTypes.func,
  createQuestionWatcher: PropTypes.func,
  deleteQuestionWatcher: PropTypes.func,
}

export default QuestionDrawer
